import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NavigationHelper from 'yoda-core-components/lib/helpers/NavigationHelper/NavigationHelper';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Barcode from 'yoda-core-components/lib/assets/svg/Barcode.svg';
import Print from 'yoda-core-components/lib/assets/svg/Print.svg';
import Button from 'yoda-core-components/lib/components/Button';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import analyticsActions from '../../actions/AnalyticsAction';
import BarCode from '../BarCode/Barcode';
import CouponListAction from '../../actions/CouponListAction';
import { selectDeviceType } from '../../selectors/ContextSelector';
import * as styles from './ShowBarCode.css';

const cx = classNames.bind(styles);

export class ShowBarCode extends Component {
    static propTypes = {
        channelName: PropTypes.string.isRequired,
        printOption: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        actions: PropTypes.object,
        barcodeData: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        modalAutoId: PropTypes.string.isRequired,
        index: PropTypes.number,
        promoCode: PropTypes.string,
        inlineBarCode: PropTypes.bool,
        redeemingChannel: PropTypes.string,
        className: PropTypes.string,
        from: PropTypes.string,
        enableModelBlockTheme: PropTypes.bool,
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        isCouponDrawer: PropTypes.bool,
    };

    static defaultProps = {
        printOption: '',
        actions: {},
        index: 0,
        barcodeData: [],
        promoCode: '',
        inlineBarCode: false,
        redeemingChannel: '',
        className: '',
        from: null,
        enableModelBlockTheme: false,
        deviceType: {},
        isCouponDrawer: false,
    };

    constructor() {
        super();
        this.state = { isModalOpen: false };
        this.openModal = this.openModal.bind(this);
    }

    /* istanbul ignore next */
    closeModal() {
        this.setState({ isModalOpen: false });
    }

    /* istanbul ignore next */
    openModal(event, isDrawer) {
        event.preventDefault();

        if (!isDrawer) {
            /** Analytics Tracking starts old barcode */
            const modalAnalyticsMessage = 'opened coupon barcode';
            this.props.actions.openModelEvent({ name: modalAnalyticsMessage });
            /** Analytics Tracking ends old barcode */
        } else {
            /** Analytics Tracking starts new barcode */
            this.props.actions.trackPrintBarCode();
            /** Analytics Tracking ends new barcode */
        }

        this.setState({ isModalOpen: true });
    }

    displayPrintButton = (printLabel, iconComponent) => {
        let printHtml = '';
        if (this.props.printOption.href) {
            printHtml = (
                <Button
                    type="button"
                    automationId="at-coupon-print-btn"
                    buttonType="Secondary"
                    size="Lg"
                    className={`${cx(this.props.className, 'buttonTheme')} ${dt([
                        'p-0',
                        'font-open-sans',
                        'w-[230px]',
                        'my-4',
                        'mx-auto',
                    ])}`}
                    onClick={() => {
                        NavigationHelper.navigate(this.props.printOption.href, true);
                    }}
                >
                    <Icon
                        iconType="svg"
                        automationId="at-coupon-print-icon"
                        width="32px"
                        height="32px"
                        viewBox="0 0 32 32"
                        pathClassName={styles.lockBtnIcon}
                        className="btnIcon"
                    >
                        {iconComponent}
                    </Icon>
                    <span className={dt(['ml-1'])}>{printLabel}</span>
                </Button>
            );
        }
        return printHtml;
    };

    displayBarcodeWithPrintBtn() {
        const {
            printOption,
            barcodeData,
            channelName,
            index,
            modalAutoId,
            promoCode,
            deviceType,
            isCouponDrawer,
        } = this.props;
        const promoCodeValue = promoCode || 'instore coupons';
        // blocking to send isMobile & isTablet to avaoid scrolling the page to top when Print barcode clicked
        let deviceTypeInfo = {
            isDesktop: deviceType.isDesktop,
        };
        // send isMobile & isTablet only for coupon page to avaoid scrolling main page when Modal opened
        if (!isCouponDrawer && !deviceType.isDesktop) {
            deviceTypeInfo = { ...deviceType };
        }

        return (
            <div
                className={cx('coupon', 'couponBarcode')}
                id={`${
                    this.props.from === 'drawer' ? 'couponDrawer|' : ''
                }Print Barcode|${promoCodeValue}`}
            >
                <Button
                    type="button"
                    automationId="at-show-barcode-btn"
                    buttonType="Secondary"
                    size="Xl"
                    className={dt([
                        'flex',
                        'items-center',
                        'justify-center',
                        '!p-0',
                        'mb-2',
                        'w-full',
                        'h-10',
                    ])}
                    ellipsis
                    onClick={
                        /* istanbul ignore next */
                        (e) => this.openModal(e, this.props.from === 'drawer')
                    }
                >
                    <Icon
                        iconType="svg"
                        automationId="at-show-barcode-icon"
                        width="35px"
                        height="35px"
                        viewBox="0 0 35 35"
                        className={dt(['relative'])}
                    >
                        <Barcode />
                    </Icon>
                    Print Barcode
                </Button>
                <ModalBox
                    showModal={this.state.isModalOpen}
                    renderModalToBody
                    deviceType={deviceTypeInfo}
                    onClose={
                        /* istanbul ignore next */
                        () => this.closeModal()
                    }
                    defaultHeader
                    automationId={modalAutoId}
                    modalTheme={`${cx('appliedModalTheme')} ${dt([
                        'p-3',
                        'mdOnly:w-[470px]',
                        'lg:w-[644px]',
                        'smOnly:w-[270px]',
                        '!overflow-y-scroll',
                    ])}`}
                    modalContentTheme={`${cx('appliedModalContentTheme')} ${dt([
                        'text-center',
                        'smOnly:mt-0',
                    ])}`}
                    modalOverlayTheme={`${cx('modalOverlay')} ${dt(['z-[100]'])}`}
                    modalBlockTheme={
                        /* istanbul ignore next */
                        this.props.enableModelBlockTheme
                            ? `${cx('safariModalBlockTheme')} ${dt(['max-h-[73vh]'])}`
                            : ''
                    }
                >
                    <div
                        className={`${cx('detailsWrapper', 'alignCenter')} ${dt([
                            'mt-0',
                            'mx-auto',
                            'mb-4',
                            'text-center',
                        ])}`}
                    >
                        <div className={cx('barcodeDetailsWrapper')}>
                            <BarCode
                                barcodeData={barcodeData}
                                channelName={channelName}
                                index={index}
                            />
                        </div>
                        {printOption.href ? this.displayPrintButton('Print', <Print />) : ''}
                    </div>
                </ModalBox>
            </div>
        );
    }

    /* istanbul ignore next */
    displayBarcodeInline() {
        const { barcodeData, channelName, index, redeemingChannel } = this.props;
        const headLineMsg =
            redeemingChannel === 'instore'
                ? 'present barcode in store'
                : 'or present barcode in store';
        return (
            <div
                className={`${cx('detailsWrapper', 'alignCenter')} ${dt([
                    'mt-0',
                    'mx-auto',
                    'mb-4',
                    'text-center',
                ])}`}
            >
                <div className={cx('barcodeDetailsWrapper')}>
                    <BarCode
                        barcodeData={barcodeData}
                        channelName={channelName}
                        index={index}
                        inlineBarCode
                        headLineMsg={headLineMsg}
                    />
                </div>
            </div>
        );
    }

    render() {
        const { barcodeData, inlineBarCode } = this.props;
        let renderBarcodeHTML =
            barcodeData && barcodeData.length > 0 ? (
                this.displayBarcodeWithPrintBtn()
            ) : (
                <div className={cx('printBtn')}>
                    {this.displayPrintButton('Print Barcode', <Barcode />)}
                </div>
            );
        /* istanbul ignore next */
        if (inlineBarCode) {
            renderBarcodeHTML =
                barcodeData && barcodeData.length > 0 && this.displayBarcodeInline();
        }

        return renderBarcodeHTML;
    }
}
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            openModelEvent: analyticsActions.openModelEvent,
            trackPrintBarCode: CouponListAction.trackPrintBarCode,
        },
        dispatch
    ),
});

const mapStateToProps = (state) => ({
    deviceType: selectDeviceType(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowBarCode);
